export default {
  GENERIC_ERROR: 'Something went wrong. Please contact us',
  EDIT_DETAILS_MENTOR_SUCCESS: 'Your details updated successfully',
  EDIT_DETAILS_APPLICATION_SUBMITTED:
    "Thanks for joining us! We'll approve your application ASAP.",
  EDIT_DETAILS_DELETE_ACCOUNT_CONFIRM:
    'Are you sure you want to delete your account?',
  CARD_APPLY_TOOLTIP:
    "Click here to Login / Register<br />to get the mentor's details",
  CARD_ANONYMOUS_LIKE_TOOLTIP:
    'Click here to Login / Register<br />to add this mentor to favorites',
  LOGOUT: 'Logout',
  CARD_APPLY_REQUEST_TOOLTIP: 'Click here to send a mentorship<br />request.',
  CARD_APPLY_REQUEST_SUCCESS: 'Your mentorship request has been sent.',
};
